import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Card, Btn, Badge, EmptyState, AInput, ATextarea } from "../AdminUI";
import { Mail, Smartphone } from "lucide-react";

export default function Templates({ kind }) {
  const base = kind === "email" ? "email-templates" : "sms-templates";
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get(`/admin/${base}`).then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); setEdit(null); }, [kind]); // eslint-disable-line

  const saveT = async () => {
    try {
      const body = kind === "email"
        ? { subject: edit.subject, body: edit.body, sender_name: edit.sender_name, reply_to: edit.reply_to }
        : { body: edit.body };
      await api.patch(`/admin/${base}/${edit.id}`, body);
      toast.success("Template saved"); setEdit(null); load();
    } catch { toast.error("Failed"); }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-head font-extrabold text-3xl text-[var(--navy)] uppercase tracking-tight">{kind === "email" ? "Email Templates" : "SMS Templates"}</h1>
        <p className="text-gray-500 text-sm">Editable templates. Sending is disabled until a provider is connected — attempted sends are logged as "Queued — sending disabled".</p>
      </div>

      <Badge color="amber">{kind === "email" ? "Email sending disabled — kill switch engaged" : "SMS sending disabled — kill switch engaged"}</Badge>

      <div className="grid grid-cols-1 gap-4">
        {items.map((t) => (
          <Card key={t.id} title={t.name} action={<Btn variant="ghost" onClick={() => setEdit(edit?.id === t.id ? null : t)} data-testid={`edit-tpl-${t.id}`}>{edit?.id === t.id ? "Close" : "Edit"}</Btn>}>
            {edit?.id === t.id ? (
              <div className="space-y-3">
                {kind === "email" && <>
                  <AInput label="Subject" value={edit.subject || ""} onChange={(e) => setEdit({ ...edit, subject: e.target.value })} />
                  <div className="grid grid-cols-2 gap-3">
                    <AInput label="Sender Name" value={edit.sender_name || ""} onChange={(e) => setEdit({ ...edit, sender_name: e.target.value })} />
                    <AInput label="Reply-To" value={edit.reply_to || ""} onChange={(e) => setEdit({ ...edit, reply_to: e.target.value })} />
                  </div>
                </>}
                <ATextarea label="Body" rows={5} value={edit.body || ""} onChange={(e) => setEdit({ ...edit, body: e.target.value })} />
                <Btn onClick={saveT} data-testid="save-tpl">Save Template</Btn>
              </div>
            ) : (
              <div className="text-sm text-gray-600">
                {kind === "email" && t.subject && <p className="font-semibold text-[var(--navy)]">{t.subject}</p>}
                <p className="whitespace-pre-wrap mt-1">{t.body}</p>
              </div>
            )}
          </Card>
        ))}
      </div>
    </div>
  );
}
